// Time Off
import {request} from "@/backend/backend_util.ts";

export type TimeoffDTO = {
    id: number;
    start: string;
    end: string;
    status: string;
    comment: string;

}

export type TimeoffStatsDTO = {
    userId: number;
    name: string;
    departmentId: number;
    total: number;
    vacation: number;
    personal: number;
    sick: number;
    parental: number;
    bereavement: number;
}

export const timeoffBackend = {
    getTimeoff: request<TimeoffDTO[]>('GET', '/time-off'),
    getPeopleTimeoffs: request<TimeoffDTO[]>('GET', '/time-off/people'),
    getAllTimeoff: request<TimeoffDTO[]>('GET', '/time-off/all'),
    getStats: (year: number) => request<TimeoffStatsDTO[]>('GET', `/time-off/stats/${year}`)(),
    getPersonTimeoff: (userId: number) => request<TimeoffDTO[]>('GET', '/time-off/' + userId)(),
    saveTimeoff: request<TimeoffDTO>('POST', '/time-off'),
    deleteTimeoff: request('DELETE', '/time-off'),
    approveTimeoff: request('POST', '/time-off/people/approve'),
    declineTimeoff: request('POST', '/time-off/people/decline'),
    updateType: (id: number, type: string) => request<TimeoffDTO>('PUT', `/time-off/${id}/type`)({type}),

}
